import {
  createContext,
  useContext,
} from "react"
import type { EditableAccountInsulin } from "src/types"

export interface AccountInsulinModalContextValue {
  openAccountInsulinModal: (
    accountInsulin?: EditableAccountInsulin,
  ) => void;
}

type ContextType = AccountInsulinModalContextValue | null
export const AccountInsulinModalContext = createContext<ContextType>(null)

export function useAccountInsulinModalContext() {
  const context = useContext(AccountInsulinModalContext)

  if (context === null) {
    throw new Error("AccountInsulinModal components must be wrapped in <AccountInsulinModalContext />")
  }

  return context
}

